<template>
  <div class="c-qt-web-channel"></div>
</template>
<script>
import { mapState } from "vuex";
import { QWebChannel } from "qwebchannel";
import { paths } from "@/router";
import { anyKeys, macroKeys } from "@/components/SpecialKeys";
import { srcKeys as srcKeysNew } from "@/views/CyberboardNew/components/KeyboardNew";
import { srcKeys as srcKeysAlice } from "@/views/Alice/components/KeyboardAlice";
import { srcKeys as srcKeys65Less } from "@/views/65Less/components/Keyboard65Less";
import { srcKeys as srcKeys65LessSplit } from "@/views/65LessSplit/components/Keyboard65LessSplit";
import { srcKeys as srcKeys65GameBoy } from "@/views/65GameBoy/components/Keyboard65GameBoy";
import { srcKeys as srcKeys65Fluffy } from "@/views/65Fluffy/components/Keyboard65Fluffy";
import { srcKeys as srcKeys80 } from "@/views/80/components/Keyboard80";
import { srcKeys as srcKeys75 } from "@/views/75/components/Keyboard75";

const keysIndexNew = srcKeysNew.map((i) => i.index);
const keysIndexAlice = srcKeysAlice.map((i) => i.index);
const keysIndex65Less = srcKeys65Less.map((i) => i.index);
const keysIndex65LessSplit = srcKeys65LessSplit.map((i) => i.index);
const keysIndex65GameBoy = srcKeys65GameBoy.map((i) => i.index);
const keysIndex65Fluffy = srcKeys65Fluffy.map((i) => i.index);
const keysIndex80 = [...srcKeys80.map((i) => i.index), 129, 130, 134];
const keysIndex75 = srcKeys75.map((i) => i.index);

export default {
  name: "CQtWebChannel",
  computed: {
    ...mapState("loader", {
      inLoader: "inLoader",
      loading: "loading",
      systemInfo: "systemInfo",
      deviceName: "deviceName",
    }),
    ...mapState([
      "profileNew",
      "profileAlice",
      "profile65Less",
      "profile65LessSplit",
      "profile65GameBoy",
      "profile65Fluffy",
      "profile80",
      "profile75",
    ]),
    type() {
      // 更新数据的类型
      const types = {
        [paths.keyboardNew]: "profileNew",
        [paths.keyboardAlice]: "profileAlice",
        [paths.keyboard65Less]: "profile65Less",
        [paths.keyboard65LessSplit]: "profile65LessSplit",
        [paths.keyboard65LessSplit]: "profile65LessSplit",
        [paths.keyboard65GameBoy]: "profile65GameBoy",
        [paths.keyboard65Fluffy]: "profile65Fluffy",
        [paths.keyboard80]: "profile80",
        [paths.keyboard75]: "profile75",
      };
      return types[this.$route.path] || "profileNew";
    },
    keysIndex() {
      // 过滤非必要的改键数据
      const indexes = {
        [paths.keyboardNew]: keysIndexNew,
        [paths.keyboardAlice]: keysIndexAlice,
        [paths.keyboard65Less]: keysIndex65Less,
        [paths.keyboard65LessSplit]: keysIndex65LessSplit,
        [paths.keyboard65GameBoy]: keysIndex65GameBoy,
        [paths.keyboard65Fluffy]: keysIndex65Fluffy,
        [paths.keyboard80]: keysIndex80,
        [paths.keyboard75]: keysIndex75,
      };
      return indexes[this.$route.path] || [];
    },
  },
  watch: {
    "profileNew.data"(newData, oldData) {
      if (this.type === "profileNew") this.downloadJSON(newData, oldData);
    },
    "profileAlice.data"(newData, oldData) {
      if (this.type === "profileAlice") this.downloadJSON(newData, oldData);
    },
    "profile65Less.data"(newData, oldData) {
      if (this.type === "profile65Less") this.downloadJSON(newData, oldData);
    },
    "profile65LessSplit.data"(newData, oldData) {
      if (this.type === "profile65LessSplit")
        this.downloadJSON(newData, oldData);
    },
    "profile65GameBoy.data"(newData, oldData) {
      if (this.type === "profile65GameBoy") this.downloadJSON(newData, oldData);
    },
    "profile65Fluffy.data"(newData, oldData) {
      if (this.type === "profile65Fluffy") this.downloadJSON(newData, oldData);
    },
    "profile80.data"(newData, oldData) {
      if (this.type === "profile80") this.downloadJSON(newData, oldData);
    },
    "profile75.data"(newData, oldData) {
      if (this.type === "profile75") this.downloadJSON(newData, oldData);
    },
  },
  methods: {
    initBridge() {
      if (window.qt) {
        // 初始化
        console.log("Bridge", "QT");
        new QWebChannel(window.qt.webChannelTransport, (channel) => {
          const bridge = channel.objects.py;
          this.$store.dispatch("loader/setBridge", bridge);
        });
        const webBridge = {
          setSystemInfo: (json) => {
            // 此功能用于上位机向 Web 设置系统信息
            console.log("Bridge", "setSystemInfo", "Start", json);
            const systemInfo = JSON.parse(json);
            this.$store.dispatch("loader/setSystemInfo", systemInfo);
            console.log("Bridge", "setSystemInfo", "End");
          },
          setCurrentDevice: (json) => {
            // 此功能用于上位机向 Web 设置当前设备
            console.log("Bridge", "setCurrentDevice", "Start", json);
            const device = JSON.parse(json);
            this.$store.dispatch("loader/setCurrentDevice", device);
            console.log("Bridge", "setCurrentDevice", "End");
          },
          uploadJSON: (json) => {
            // 此功能用于上位机向 WEB 同步键盘信息，为空时代表信息一致无需同步
            console.log("Bridge", "uploadJSON", "Start");
            if (json) {
              const newData = JSON.parse(json);
              console.log(this.type, newData);
              const data = this[this.type].data;
              newData.layers.map((layer, layerIndex) => {
                data.key_layer.layer_data[
                  layerIndex
                ].layer = layer.layer.map((i) => i.toUpperCase());
              });
              data.tab_key = newData.tab_key.map((i) => {
                let tab_key = {
                  ph_key_data: i.ph_key_data.toUpperCase(),
                  first_key: i.first_key.toUpperCase(),
                  second_key: i.second_key.toUpperCase(),
                  interval_time: i.interval_time,
                  new_key: i.ph_key_data.toUpperCase(),
                  old_key: i.old_key,
                };
                newData.layers.map((layer, layerIndex) => {
                  const index = layer.layer.findIndex(
                    (key) => key === i.ph_key_data
                  );
                  if (index >= 0) {
                    tab_key = {
                      ...tab_key,
                      layer_num: layerIndex, //当前键层
                      row_num: Math.floor(index / 25), //行
                      index: index % 25, //列
                    };
                  }
                });
                return tab_key;
              });
              data.macro_key = newData.macro_key.map((i) => ({
                original_key: i.original_key.toUpperCase(),
                layer_key: i.layer_key.map((i) => i.toUpperCase()),
                intvel_ms: i.intvel_ms,
              }));
              this.$store.dispatch(this.type + "/setData", data);
              console.log("Bridge", "uploadJSON", "End", this.type, newData);
            } else {
              console.log(this.type, null);
              console.log("Bridge", "uploadJSON", "End");
            }
            setTimeout(() => {
              this.$store.dispatch("loader/setLoading", false);
            }, 100);
          },
          downloadSuccessfully: (successfully) => {
            // 此功能用于上位机向 WEB 发送下载成功信息
            console.log("Bridge", "downloadSuccessfully");
            successfully &&
              this.$message.info(this.$t("keyboard.downloadSuccessfully"));
            this.$store.dispatch("loader/setLoading", false);
          },
          initChangeDict: (json) => {
            console.log("Bridge", "initChangeDict", json);
            if (json) {
              const data = JSON.parse(json);
              const deviceName = { ...this.deviceName, ...data };
              this.$store.dispatch("loader/setDeviceName", deviceName);
              console.log("initChangeDict", "true");
            }
          },
        };
        for (const key in webBridge) {
          window[key] = webBridge[key];
        }
      }
    },
    downloadJSON(newData, oldData) {
      // 此功能用于 WEB 向上位机同步键盘信息
      // if (this.loading || !this.inLoader) return;
      console.log("Bridge", "downloadJSON", "Start", this.type);
      let list = [];
      newData.key_layer.layer_data.map((layer, layerIndex) => {
        layer.layer.map((key, index) => {
          const oldKey = oldData.key_layer.layer_data[layerIndex].layer[index];
          if (oldKey !== key && this.keysIndex.includes(index)) {
            let data = {
              msg_type: 0, // 0: '实时改键', 1: 'press&hold', 2: '宏',
              layer_num: layerIndex, //当前键层
              row_num: Math.floor(index / 25), //行
              index: index % 25, //列
              old_key: oldKey, //旧键值
              new_key: key, //新键值
            };
            if (anyKeys.includes(key)) {
              const anyKey = newData.tab_key.find((k) => k.ph_key_data === key);
              data = {
                ...data,
                ...anyKey,
                msg_type: 1,
                tab_key: newData.tab_key,
              };
            }
            if (macroKeys.includes(key)) {
              data = {
                ...data,
                msg_type: 2,
                macro_key: newData.macro_key,
              };
            }
            list.push(data);
          }
        });
      });
      console.log("Bridge", "downloadJSON", "Length", list.length);
      if (list.length > 0) {
        this.$store.dispatch("loader/setLoading", list.length > 5);
        this.$store.dispatch("loader/downloadJSON", list);
      } else {
        // this.$store.dispatch("loader/setLoading", false);
      }
    },
  },
  mounted() {
    this.initBridge();
  },
};
</script>
<style lang="scss" scoped></style>
